import { connect } from 'react-redux';

import { AboutLayout, IAboutLayoutProps } from './AboutLayout';
import { IState } from '../../../store';
import { MODERATION_STATUS_TYPES } from '../../../types';
import { getVillageOffersType } from '../../../utils/getVillageOffersType';
import { getCounterSetOnSale } from '../../../utils/helpers';

export function mapStateToProps(state: IState): IAboutLayoutProps {
  const {
    builder,
    counterSet = {},
    finishYearMax,
    finishYearMin,
    name,
    priceMax,
    priceMin,
  } = state.villageData.village;

  return {
    builderName: builder && builder.moderationStatus === MODERATION_STATUS_TYPES.Published ? builder.name : '',
    counterInSale: getCounterSetOnSale(counterSet),
    counterTotal: counterSet.total,
    finishYearMax,
    finishYearMin,
    name,
    priceMax,
    priceMin,
    isFat: state.isFatCard,
    isCroppedCard: state.isCroppedCard,
    offersType: getVillageOffersType(state),
  };
}

export const AboutLayoutContainer = connect<IAboutLayoutProps>(mapStateToProps)(AboutLayout);
